<div class="container" *ngIf="technicalInfo?.tracks">
	<div class="items" *ngIf="technicalInfo.tracks['General']">
		<h3>
			{{ 'GENERAL' | translate }}
		</h3>
		<div class="info" *ngFor="let info of technicalInfo.tracks['General'] | keyvalue">
			<div>{{ info.key }}</div>
			<div class="value">{{ info.value }}</div>
		</div>
	</div>
	<div class="items" *ngIf="technicalInfo?.tracks['Video']">
		<h3>
			{{ 'VIDEO' | translate }}
		</h3>
		<div class="info" *ngFor="let info of technicalInfo?.tracks['Video'] | keyvalue">
			<div>{{ info.key }}</div>
			<div class="value">{{ info.value }}</div>
		</div>
	</div>
	<div class="items" *ngIf="technicalInfo.tracks['Audio']">
		<h3>
			{{ 'AUDIO' | translate }}
		</h3>
		<div class="info" *ngFor="let info of technicalInfo.tracks['Audio'] | keyvalue">
			<div>{{ info.key }}</div>
			<div class="value">{{ info.value }}</div>
		</div>
	</div>
</div>